<script>
export default {
  name: 'Video',
  props: {
    videoId: {
      type: [Number, String],
      required: true,
    },
    videoTitle: {
      type: String,
      required: true,
    },
  },
  head: {
    script: [
      {
        type: 'text/javascript',
        src: 'https://players.brightcove.net/5972928206001/default_default/index.min.js',
        async: 'async',
        body: true,
      },
    ],
  },
  data() {
    return {
      accountNo: '5972928206001',
      playerId: 'default',
    };
  },
};
</script>

<template>
  <div class="bc-video-container">
    <video
      id="player"
      :data-video-id="videoId"
      :data-account="accountNo"
      :data-player="playerId"
      data-embed="default"
      data-application-id
      class="video-js"
      autoplay
      controls
      style="height: 100%; width: 100%;"
    ></video>
    <h2 class="bc-video-title">{{ videoTitle }}</h2>
  </div>
</template>
